import React from 'react';
import { Card, CardContent } from '../../../../../../../components/ui/card';

interface JobParametersProps {
    jobData: any;
}

const JobParameters: React.FC<JobParametersProps> = ({ jobData }) => {
    return (
        <div className="p-6 space-y-4">
            <Card className="bg-white border border-[#E2E5EA] shadow-sm">
                <CardContent className="p-5 w-full">
                    <h3 className="text-[14px] font-semibold text-blueprint-blue mb-4">Identification</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Bug Number</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.Identification?.find((item: any) => item['Bug Number'])?.['Bug Number'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Station Number</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.Identification?.find((item: any) => item['Station Number'])?.['Station Number'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Weld Number</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.Identification?.find((item: any) => item['Weld Number'])?.['Weld Number'] || '-'}
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
            
            <Card className="bg-white border border-[#E2E5EA] shadow-sm">
                <CardContent className="p-5 w-full">
                    <h3 className="text-[14px] font-semibold text-blueprint-blue mb-4">Machine Setup</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Spool Weight</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const spoolWeightData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Spool Weight']);
                                    if (spoolWeightData?.['Spool Weight']) {
                                        const weightArray = spoolWeightData['Spool Weight'];
                                        const value = weightArray.find((item: any) => typeof item === 'string');
                                        const unit = weightArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'lb'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Adjustable Oscillation Width Enable</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Adjustable Oscillation Width Enable'])?.['Adjustable Oscillation Width Enable'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Auto Tilt Based Welding</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Auto Tilt Based Welding'])?.['Auto Tilt Based Welding'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Bug Type</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Bug Type'])?.['Bug Type'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Display Measurements</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Display Measurements'])?.['Display Measurements'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Post Purge Time (GPo)</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const purgeData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Post Purge Time (GPo)']);
                                    if (purgeData?.['Post Purge Time (GPo)']) {
                                        const purgeArray = purgeData['Post Purge Time (GPo)'];
                                        const value = purgeArray.find((item: any) => typeof item === 'string');
                                        const unit = purgeArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 's'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Special Cycle</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Special Cycle'])?.['Special Cycle'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Stop Weld If Out Of Limits</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Stop Weld If Out Of Limits'])?.['Stop Weld If Out Of Limits'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Stop Weld On Sensing Error</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Stop Weld On Sensing Error'])?.['Stop Weld On Sensing Error'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Vertical Torch Increment</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const incrementData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Vertical Torch Increment']);
                                    if (incrementData?.['Vertical Torch Increment']) {
                                        const incrementArray = incrementData['Vertical Torch Increment'];
                                        const value = incrementArray.find((item: any) => typeof item === 'string');
                                        const unit = incrementArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'in'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Vertical Target Increment Amps</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const ampsData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Vertical Target Increment Amps']);
                                    if (ampsData?.['Vertical Target Increment Amps']) {
                                        const ampsArray = ampsData['Vertical Target Increment Amps'];
                                        const value = ampsArray.find((item: any) => typeof item === 'string');
                                        const unit = ampsArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'A'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Vertical Target Increment Volts</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const voltsData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Vertical Target Increment Volts']);
                                    if (voltsData?.['Vertical Target Increment Volts']) {
                                        const voltsArray = voltsData['Vertical Target Increment Volts'];
                                        const value = voltsArray.find((item: any) => typeof item === 'string');
                                        const unit = voltsArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'V'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Vertical Target Increment Res</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const resData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Vertical Target Increment Res']);
                                    if (resData?.['Vertical Target Increment Res']) {
                                        const resArray = resData['Vertical Target Increment Res'];
                                        const value = resArray.find((item: any) => typeof item === 'string');
                                        const unit = resArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'mΩ'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Horizontal Bias Increment Amps</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const ampsData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Horizontal Bias Increment Amps']);
                                    if (ampsData?.['Horizontal Bias Increment Amps']) {
                                        const ampsArray = ampsData['Horizontal Bias Increment Amps'];
                                        const value = ampsArray.find((item: any) => typeof item === 'string');
                                        const unit = ampsArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'A'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Horizontal Bias Increment Volts</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const voltsData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Horizontal Bias Increment Volts']);
                                    if (voltsData?.['Horizontal Bias Increment Volts']) {
                                        const voltsArray = voltsData['Horizontal Bias Increment Volts'];
                                        const value = voltsArray.find((item: any) => typeof item === 'string');
                                        const unit = voltsArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'V'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Horizontal Bias Increment Res</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const resData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Horizontal Bias Increment Res']);
                                    if (resData?.['Horizontal Bias Increment Res']) {
                                        const resArray = resData['Horizontal Bias Increment Res'];
                                        const value = resArray.find((item: any) => typeof item === 'string');
                                        const unit = resArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'mΩ'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Welding G</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Welding G'])?.['Welding G'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Width Delta</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const widthData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Width Delta']);
                                    if (widthData?.['Width Delta']) {
                                        const widthArray = widthData['Width Delta'];
                                        const value = widthArray.find((item: any) => typeof item === 'string');
                                        const unit = widthArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'in'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Enable Pendant Weld ID Change</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Enable Pendant Weld ID Change'])?.['Enable Pendant Weld ID Change'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Weld ID Unchanged Warning</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Weld ID Unchanged Warning'])?.['Weld ID Unchanged Warning'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Torch Distance</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const distanceData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Machine Setup']?.find((item: any) => item['Torch Distance']);
                                    if (distanceData?.['Torch Distance']) {
                                        const distanceArray = distanceData['Torch Distance'];
                                        const value = distanceArray.find((item: any) => typeof item === 'string');
                                        const unit = distanceArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'in'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
            
            <Card className="bg-white border border-[#E2E5EA] shadow-sm">
                <CardContent className="p-5 w-full">
                    <h3 className="text-[14px] font-semibold text-blueprint-blue mb-4">Motor Jog Setup</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Reverse Travel Speed</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const speedData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Motor Jog Setup']?.find((item: any) => item['Reverse Travel Speed']);
                                    if (speedData?.['Reverse Travel Speed']) {
                                        const speedArray = speedData['Reverse Travel Speed'];
                                        const value = speedArray.find((item: any) => typeof item === 'string');
                                        const unit = speedArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'in/min'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Wire Reverse Enable</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Motor Jog Setup']?.find((item: any) => item['Wire Reverse Enable'])?.['Wire Reverse Enable'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Forward Travel Speed</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const speedData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Motor Jog Setup']?.find((item: any) => item['Forward Travel Speed']);
                                    if (speedData?.['Forward Travel Speed']) {
                                        const speedArray = speedData['Forward Travel Speed'];
                                        const value = speedArray.find((item: any) => typeof item === 'string');
                                        const unit = speedArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'in/min'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>

            <Card className="bg-white border border-[#E2E5EA] shadow-sm">
                <CardContent className="p-5 w-full">
                    <h3 className="text-[14px] font-semibold text-blueprint-blue mb-4">Logging Setup</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Cycles Between Auto Logs</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Logging Setup']?.find((item: any) => item['Cycles Between Auto Logs'])?.['Cycles Between Auto Logs'] || '-'}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">Logging Distance</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {(() => {
                                    const distanceData = jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Logging Setup']?.find((item: any) => item['Logging Distance']);
                                    if (distanceData?.['Logging Distance']) {
                                        const distanceArray = distanceData['Logging Distance'];
                                        const value = distanceArray.find((item: any) => typeof item === 'string');
                                        const unit = distanceArray.find((item: any) => item?.Unit)?.Unit;
                                        return value ? `${value} ${unit || 'in'}` : '-';
                                    }
                                    return '-';
                                })()}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">User Log Marks</div>
                            <div className="text-[13px] font-medium text-text-grey">
                                {jobData?.parsed_json_data?.['JOB PARAMETERS']?.['Logging Setup']?.find((item: any) => item['User Log Marks'])?.['User Log Marks'] || '-'}
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default JobParameters;
